import img from "../../images/porfirio.jpg";
import img4 from "../../images/pintura.jpg";
import img6 from "../../images/tourismInMexico.jpg";
import img7 from "../../images/candids.jpg";
import Icon1 from "../../images/svg-4.svg";
import Icon2 from "../../images/svg-5.svg";
import Icon3 from "../../images/svg-6.svg";
import Icon4 from "../../textiles_png/3_textiles/AT-2020-16-2.png";
import Icon5 from "../../textiles_png/3_textiles/AT-2020-16-3.png";
import Icon6 from "../../textiles_png/3_textiles/AT-2020-16-4.png";
import Icon7 from "../../textiles_png/3_textiles/AT-2020-16-5.png";

export const homeObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "",
  headline: "Introduction",
  description:
    "Join Zapotec textile artist Porfirio Gutiérrez and ASM curators to learn about the iconic Mexican Saltillo sarape’s history, regional influence, and contemporary manifestations. Discover how Indigenous textiles embody the interconnection of peoples, traditions, arts, culture, and environmental stewardship.",
  description2:
    "For thousands of years, Indigenous people of the Americas have woven textiles on backstrap looms using local materials, including cotton, other plant fibers, and animal hair. In Mexico, as in other parts of the Americas, weaving practices were further shaped by Spanish colonization, which introduced sheep and the treadle loom. The distinctive Saltillo sarape design developed out of this early colonial period. Today, Indigenous and Hispanic weavers in Mexico and the southwestern United States continue to interpret the Saltillo sarape’s designs.",
  description3:
    "A sarape is a woolen blanket woven longer than it is wide. Named for the town of Saltillo, where they were popular trade items from the 1600s to the 1800s, Saltillo sarapes are distinguished by a central diamond design or a circular medallion on a contrasting background enclosed by a border design. Traditionally, they are woven on treadle looms with wool yarn colored by natural dyes derived from plants, such as indigo (Indigofera tinctoria), and from cochineal, an insect.",
  buttonLabel: "",
  cap: "Porfirio Gutiérrez.",
  cap2: "Joe Coca, photographer, 2019",
  imgStart: false,
  img: img,
  alt: "Car",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjFour = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "",
  headline: "THE LOOM",
  description:
    "Spain imposed the European guild system on textile production, which dictated who could perform certain tasks. As a result, men were employed as weavers in the obrajes (textile workshops). They used European treadle looms with foot pedals to produce fabric for export, for domestic use, and to fulfill tribute payments to the Spanish authorities. The Aztecs had also demanded tribute in the form of textiles from those they conquered. ",
  description2:
    " The treadle looms could quickly produce wide textiles that had tighter warp tension, which is important for creating complicated designs like those in Saltillo sarapes. In the obrajes, yarn was spun on European-style spinning wheels, which further increased production speed. Indigenous women, who traditionally were the weavers, continued to use hand spindles for spinning the yarns and the backstrap loom to weave their own clothing and household textiles.",
  description3:
    "An early colonial weaving workshop with Indigenous men weaving and spinning while a Spanish official oversees them. The loom combines elements of both the backstrap and treadle looms.",
  buttonLabel: "",
  imgStart: false,
  img: img4,
  alt: "Car",
  cap: "Pintura del Gobernador, Alcaldes, y Regidores de México, 1565",
  cap2: "Codex Osuna, page 79",
  cap3: "Biblioteca National de España",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjFive = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "",
  headline: "",
  description: "",
  description2: "",
  buttonLabel: "",
  imgStart: false,
  img: img,
  alt: "Car",
  dark: true,
  primary: true,
  darkText: false,
};

export const tourismObjOne = {
  id: "SectionOne",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "",
  headline: "Tourism and the Saltillo",
  description:
    "The Mexican nationalist movement of the early 1900s, appropriated the country’s Spanish and Indigenous identities to create a hybrid “Mexican” identity. The Saltillo sarape turned out to be one of the country’s most enduring symbols. This period saw the rise of the rainbow-striped blanket, which became synonymous with Mexico through its use in films, posters, and advertising. ",
  description2:
    "As tourism to Mexico increased, many visitors purchased these colorful sarapes as souvenirs. With demand on the rise, sarape-manufacturing plants were established. Through the use of electric-powered looms, synthetic dyes, and acrylic yarns, production time was shortened and the number of textiles increased. As a result, by the 1930s, there was a drastic decline in handwoven sarapes and the use of natural-dyed yarns.",
  buttonLabel: "",
  imgStart: false,
  img: img6,
  alt: "Paper",
  dark: true,
  primary: true,
  darkText: false,
};

export const tourismObjTwo = {
  id: "SectionTwo",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "",
  headline: "Tourism and the Saltillo",
  description:
    "Mexican ceramic artists in the area of Guadalajara responded to the tourist market by creating miniature scenes of Mexican people from the 1800s. Often, the male figures who rode or worked with horses were depicted wearing Saltillo sarapes.",
  description2:
    "The attire of the two male figures wrapped in Saltillo sarapes indicates they are part of the upper class. The vaquero carries a sarape rolled up behind his saddle. ",
  buttonLabel: "",
  imgStart: true,
  img: img6,
  alt: "Paper",
  dark: true,
  primary: true,
  darkText: true,
};

export const tourismObjThree = {
  id: "SectionThree",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "",
  headline: "Tourism and the Saltillo",
  description:
    "This photo shows tourists wearing Saltillo sarapes and sombreros while visiting Tijuana, Mexico. These items would have been purchased as souvenirs and gifts, increasing their recognition as symbols of Mexico.",
  buttonLabel: "",
  imgStart: false,
  img: img6,
  alt: "Paper",
  dark: true,
  primary: true,
  darkText: false,
};

export const tourismObjFour = {
  id: "SectionFour",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "",
  headline: "Tourism and the Saltillo",
  description:
    "Oaxaca continues to be an important weaving center whose textiles are sold worldwide. Most Zapotec weavers now use synthetic dyes, rather than the traditional natural dyes, which cuts down on the work and makes production faster.",
  buttonLabel: "",
  imgStart: true,
  img: img7,
  alt: "Paper",
  dark: true,
  primary: true,
  darkText: true,
};

export const SarapeObj1 = {
  id: "",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "",
  headline: "",
  description: "This is a Sarape",
  buttonLabel: "",
  imgStart: true,
  img: Icon1,
  alt: "Paper",
  dark: true,
  primary: true,
  darkText: true,
};

export const SarapeObj2 = {
  id: "",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "",
  headline: "",
  description: "",
  buttonLabel: "",
  imgStart: true,
  img: Icon2,
  alt: "Paper",
  dark: true,
  primary: true,
  darkText: true,
};
export const SarapeObj3 = {
  id: "",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "",
  headline: "",
  description: "",
  buttonLabel: "",
  imgStart: true,
  img: Icon3,
  alt: "Paper",
  dark: true,
  primary: true,
  darkText: true,
};
export const SarapeObj4 = {
  id: "",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "",
  headline: "",
  description: "",
  buttonLabel: "",
  imgStart: true,
  img: Icon4,
  alt: "Paper",
  dark: true,
  primary: true,
  darkText: true,
};
export const SarapeObj5 = {
  id: "",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "",
  headline: "",
  description: "",
  buttonLabel: "",
  imgStart: true,
  img: Icon5,
  alt: "Paper",
  dark: true,
  primary: true,
  darkText: true,
};
export const SarapeObj6 = {
  id: "",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "",
  headline: "",
  description: "",
  buttonLabel: "",
  imgStart: true,
  img: Icon6,
  alt: "Paper",
  dark: true,
  primary: true,
  darkText: true,
};
export const SarapeObj7 = {
  id: "",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "",
  headline: "",
  description: "",
  buttonLabel: "",
  imgStart: true,
  img: Icon7,
  alt: "Paper",
  dark: true,
  primary: true,
  darkText: true,
};
